// src/components/Body.tsx
"use client";

import { useEffect } from "react";
import BodyAttributes from "@/components/global/BodyAttributes";
import MainMenu from "@/components/global/MainMenu";

interface MainBodyProps {
  children: React.ReactNode;
  menuVariant?: 'dark' | 'light' | 'market';
}

export default function Body({ children, menuVariant = 'dark' }: MainBodyProps) {
  useEffect(() => {
    // Initialize AOS
    if (typeof window !== "undefined") {
      import("aos").then(AOS => {
        AOS.init({
          duration: 1000,
          easing: "ease-in-out",
          once: false,
          mirror: true,
        });
        //console.log("✅ AOS Initialized Successfully");
      });
    }

    const handleLoad = () => {
      setTimeout(() => {
        const preloader = document.getElementById("preloader");
        if (preloader) {
          preloader.style.display = "none";
        }
      }, 350);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <>
      <BodyAttributes />
      {/* Main Content */}
      
        <MainMenu variant={menuVariant} />
        {children}
      
    </>
  );
}
